<script setup lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Virtual } from 'swiper/modules';
import type { Swiper as SwiperClass } from 'swiper/types';
import { useElementSize } from '@vueuse/core';
import 'swiper/css';
import 'swiper/css/virtual';

const props = withDefaults(defineProps<{
  items?: Date[];
  index?: number;
}>(), {
  items: () => [],
  index: 0,
});

defineSlots<{
  default?(props: { item: Date }): void;
}>();

const { index } = toRefs(props);

const swiper = ref<SwiperClass>();

watch(index, () => {
  if (swiper.value?.activeIndex < index.value && index.value < swiper.value?.activeIndex + slidesPerView.value) return;
  swiper.value?.slideTo(index.value, 500);
});

const modules = [Virtual];

const swiperEl = ref();
const { width } = useElementSize(swiperEl);
const GAP = 12;
const SLIDE_SIZE = 32;
const slidesPerView = computed(() => Math.max(Math.floor((width.value - GAP) / (SLIDE_SIZE + GAP)), 4));

defineEmits(['update:focus']);
</script>

<template lang="pug">
Swiper.swiper.h-66.select-none(
  ref="swiperEl"
  :slidesPerView="slidesPerView"
  :virtual="{ addSlidesBefore: 30, addSlidesAfter: 30, enabled: true }"
  :modules="modules"
  :initialSlide="0"
  @transitionEnd="$emit('update:focus', swiper?.activeIndex)"
  @swiper="swiper = $event"
)
  SwiperSlide.br-8(v-for="(item, i) of items" :key="i" :virtualIndex="i")
    slot(:item="item")
</template>

<style scoped lang="scss">
//
</style>